import React from "react"

import { AppButtonIcon } from "@components"
import { BIIsLoadingChart } from "../../@signals"

export default function BIChartActions({ setIsVisible }) {

	return <AppButtonIcon
		sx={{ mr: 4 }}
		iconProps={{ iconWeight: "solid" }}
		tooltip="Show/Hide Legend"
		icon={"eye-slash"}
		onClick={() => {
			BIIsLoadingChart.value = true
			setTimeout(() => {
				BIIsLoadingChart.value = false
			}, 100)
			setIsVisible()
		}}
	/>
}